
function getPasswordStrategy(): string {
  const passwordStrategy =
    (typeof process !== 'undefined' && process.env.NEXT_PUBLIC_PASSWORD_STRATEGY) ?
      process.env.NEXT_PUBLIC_PASSWORD_STRATEGY :
      '^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])[a-zA-Z0-9._\\-\\W]{8,}$';
  return passwordStrategy;
}

export const passwordStrategy = getPasswordStrategy();
